/* ==========================================================================
   Design System
   Advanced Typography
   ========================================================================== */
/* ==========================================================================
   Design System
   Variables
   ========================================================================== */
/* ==========================================================================
   Design System
   Breakpoint variables.

   NOTE: If any of the values in this file are adjusted,
         they need to be adjusted in vars-breakpoints.js as well.
   ========================================================================== */
/* ==========================================================================
   Design System
   Grid mixins
   ========================================================================== */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* ==========================================================================
   Design System
   Media queries
   ========================================================================== */
/* ==========================================================================
   Design System
   Base styles
   ========================================================================== */
.a-date {
  color: var(--gray);
  white-space: nowrap;
  font-size: 0.875em;
  font-weight: 600;
  letter-spacing: 1px;
  line-height: 1.25;
  text-transform: uppercase;
  margin-bottom: 1.0714285714em;
}
p + .a-date, ul + .a-date, ol + .a-date, dl + .a-date, figure + .a-date, img + .a-date, table + .a-date, blockquote + .a-date, h1 + .a-date, .h1 + .a-date, h2 + .a-date, .h2 + .a-date, h3 + .a-date, .h3 + .a-date, h4 + .a-date, .h4 + .a-date, h6 + .a-date, .h6 + .a-date {
  margin-top: 2.1428571429em;
}